import React from 'react';
import { browserHistory } from 'react-router';
import Form from './Form';

// Página de detalhe/edição de funcionário (substitui o modal para essa rota).
// O próprio Form.js é reaproveitado em modo página (prop pageMode) — mesma lógica e campos,
// só troca o wrapper (Dialog vira conteúdo direto da página) e o título (nome do funcionário).
//
// /funcionarios/novo abre o cadastro de uma pessoa nova no mesmo layout em
// cards, com os campos abertos para preencher (edicao = false). CPF nunca é
// "novo", então a rota não colide com a ficha de ninguém.
//
// key = cpf: depois de cadastrar, a página navega para a ficha da pessoa
// nova; a chave diferente remonta o formulário já carregando os dados dela.
const FuncionarioDetalhe = ({ params }) => {
  const voltarParaLista = () => browserHistory.push(`${process.env.PUBLIC_URL}/funcionarios`);
  const novo = params.cpf === 'novo';

  return (
    <Form
      key={params.cpf}
      pageMode
      open
      edicao={!novo}
      funcionario={novo ? '' : params.cpf}
      close={voltarParaLista}
      carregaTabela={voltarParaLista}
    />
  );
};

export default FuncionarioDetalhe;
